import ShopifyService from "../service/shopifyService";

//
const shopify = {
  namespaced: true,
  state: {
    shopify,
    checkout: null
  },
  mutations: {
    createService: (state, client) => {
      state.shopify = new ShopifyService(client);
    },
    setShopifyCheckout: (state, checkout) => {
      state.checkout = checkout;
      state.shopify.previousCartId = checkout.id;
    }
  },
  actions: {
    getAllProducts: async ({ state }) => {
      const data = await state.shopify.getAllProducts();
      return data;
    },
    clearCart: async ({ state, commit }) => {
      const checkout = await state.shopify.createCheckout();
      commit("setShopifyCheckout", checkout);
    },
    getAllProductsFromCollection: async ({ state }, collectionId) => {
      const data = await state.shopify.getProductsForCollection(collectionId);
      return data.products;
    },
    createShopifyService: async ({ commit }, params) => {
      const domain = await params.domain;
      const token = await params.token;
      const s = ShopifyService.createClient(domain, token);
      commit("createService", s);
    },
    addProductToShopifyCart: async (
      { commit, state, dispatch },
      productVariant
    ) => {
      if (state.checkout == null) {
        await dispatch("retrieveOrCreateCheckout");
      }
      const cart = await state.shopify.addProductToCart(
        state.checkout.id,
        productVariant
      );
      commit("setShopifyCheckout", cart);
    },
    removeProductFromShopifyCart: async ({ commit, state }, lineItem) => {
      const cart = await state.shopify.removeVariantsFromCart(
        state.checkout.id,
        [lineItem.id]
      );
      commit("setShopifyCheckout", cart);
    },
    retrieveOrCreateCheckout: async ({ commit, state }) => {
      const previousCartId = state.shopify.previousCartId;
      if (previousCartId == null) {
        const checkout = await state.shopify.createCheckout();
        commit("setShopifyCheckout", checkout);
      } else {
        let checkout = null;
        try {
          checkout = await state.shopify.getCheckout(previousCartId);
        } catch (e) {
          checkout = await state.shopify.createCheckout();
        }
        checkout = checkout ? checkout : await state.shopify.createCheckout();
        commit("setShopifyCheckout", checkout);
      }
    },
    increaseBasketItem: async ({ commit, state }, lineItem) => {
      const checkout = await state.shopify.updateLineItem(
        state.checkout.id,
        lineItem,
        lineItem.quantity + 1
      );
      commit("setShopifyCheckout", checkout);
    },
    descreaseBasketItem: async ({ dispatch, commit, state }, lineItem) => {
      if (lineItem.quantity == 1) {
        return dispatch("removeProductFromShopifyCart", lineItem);
      } else {
        const checkout = await state.shopify.updateLineItem(
          state.checkout.id,
          lineItem,
          lineItem.quantity - 1
        );
        commit("setShopifyCheckout", checkout);
      }
    },
    updateCartAttribute: async ({ commit, state }, input) => {
      const checkout = await state.shopify.setCartAttribute(state.shopify.previousCartId, input.key, input.value);
      commit("setShopifyCheckout", checkout);
      return checkout;
    },
    fetchProduct: async ({ commit, state }, productId) => {
      const productData = await state.shopify.getProduct(productId);
      return productData;
    }
  },
  getters: {
    contains: state => id => {
      const c = state.checkout;
      if (c == null) return false;
      return c.lineItems.find(item => item.variant.id == id) !== undefined;
    },
    lineItem: state => variantId => {
      const c = state.checkout;
      if (c == null) return null;
      return c.lineItems.find(item => item.variant.id == variantId);
    },
    primaryShopifyDomain: (state, getters) => {
      return "shopcheckout.mindfulchef.com";
    }
  }
};
//
export default shopify;
